import { InjectionToken } from '@angular/core';

export interface RecaptchaConfig {
	disabled: boolean;
}

/** Each AppModule provides this from its own `environment.recaptcha?.disabled`. */
export const RECAPTCHA_CONFIG = new InjectionToken<RecaptchaConfig>('RECAPTCHA_CONFIG');
